<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-accordion
        id="accordion"
        [multiple]="false"
        (onOpen)="abrirAcordeon($event)"
      >
        <p-accordionTab
          header="{{ 'TIPOOCUPACION.LBL_TIPOOCUPACIONCONFIGURACION' | translate }}"
          [selected]="tabSeleccionado === 'TIPOCU'"
        >
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_TIPOOCUPACION' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8 "><strong>{{tipOcupacion.nombreTipoOcupacion}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_INGRESOS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorIngresos ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_ACTIVOS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorActivos ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_NUMEROEMPLEADOS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorNumeroEmpleados ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_NIVELENDEUDAMIENTO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorNivelEndeudamiento ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_SECTOR' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorSector ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_TIPOCONTRATO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorTipoContrato ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_EMPLEADOR' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorEmpleador ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_MANEJAACTIVIDADES' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorManejaActividades ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_GENERO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorGenero ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_EDAD' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorEdad ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>
          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_UNIDADPRODUCTIVA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorUnidadProductiva ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>

          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_ANALIZAMOS' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorAnalizamos ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_FLUJODIGITAL' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorFlujoDigital ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>

          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_PAGADURIA' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorPagaduria ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_FONDOPENSION' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorFondoPension ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>

          <div class="grid">
            <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'TIPOOCUPACION.LBL_INDICADORTIPOOCUPACION' | translate }}:</label>
            <label class="lg:col-3 col-6 md:col-8"><strong>{{tipOcupacion.indicadorTipoOcupacion ? ('LBL_SI' | translate) : ('LBL_NO' |
              translate)}}</strong></label>
          </div>

        </p-accordionTab>
        <p-accordionTab
          header="{{ 'TIPOOCUPACION.LBL_CONFIGURACIONFLUJODIGITAL' | translate }}"
          [selected]="tabSeleccionado === 'FLUDIG'" *ngIf="tipOcupacion && tipOcupacion.indicadorFlujoDigital"
        >
          <app-flujos-creditos-digitales [tipOcupacion]="tipOcupacion" [flujoDigital]="canales.TIPOOCUPACION" [esDetalle]="true"></app-flujos-creditos-digitales>
        </p-accordionTab>
      </p-accordion>




    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
